import Semaphore from "./Semaphore";

class Mutex {
  constructor() {
    this._semaphore = new Semaphore(1)
  }

  runExclusion(callback) {
    return this._semaphore.runExclusion(async () => {
      await callback();
    });
  }

  isLocked() {
    return this._semaphore.isLocked();
  }
}

export default Mutex;